import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const gsapMagneticButton = (function ($) {

    gsap.registerPlugin(ScrollTrigger);

    const $magneticButton = gsap.utils.toArray(".js-magnetic-button");

    function parallaxIt(e, button, target, movement){
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        let boundingRect = button.getBoundingClientRect();
        let relX = e.pageX - boundingRect.left;
        let relY = e.pageY - boundingRect.top;

        gsap.to(target, {
            duration: 0.2,
            x: (relX - boundingRect.width/2) / boundingRect.width * movement,
            y: (relY - boundingRect.height/2 - scrollTop) / boundingRect.width * movement,
            // ease: "power2.inOut",
        });
    }

    function init() {

        ScrollTrigger.matchMedia({
            // desktop
            "(min-width: 1024px) and (prefers-reduced-motion: no-preference)": function() {
                $magneticButton.forEach(function (button) {
                    button.content = button.querySelector(".btn__content");
                    button.border = button.querySelector(".btn__border");

                    button.addEventListener("mouseleave", function(e) {
                        gsap.to(button.content,
                            {
                                duration: 0.2,
                                x: 0,
                                y: 0
                            });
                        gsap.to(button.border,
                            {
                                duration: 0.2,
                                x: 0,
                                y: 0
                            });
                    });

                    button.addEventListener("mousemove", function(e) {
                        parallaxIt(e, button, button.content, 60);
                        parallaxIt(e, button, button.border, 80);
                    });

                })
            },

            // mobile
            "(max-width: 1023px)": function() {

            }
        })

    }

    return {
        init: init
    }

})(jQuery);